import React from 'react';
import { Flex, theme } from 'antd';

import RuleConditionDisplay from '@totem/components/rulesEngine/report/ruleConditionDisplay';
import { RuleCondition, RuleGroup } from '@totem/components/rulesEngine/types';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  group: RuleGroup;
};

const RuleGroupDisplay = ({ group }: Props) => {
  const { token } = theme.useToken();

  const groupOperatorStyle = {
    borderRightStyle: 'solid' as const,
    borderRightWidth: '2px',
    borderRightColor: token.colorBorder,
    paddingRight: '5px',
  };

  return (
    <Flex justify={'flex-start'} gap={'small'}>
      <div style={groupOperatorStyle}>{group.operator}</div>
      <div>
        {isNotNull(group.conditions) &&
          group.conditions.map((condition: RuleCondition, idx: number) => {
            const conditionKey = `${condition.id ?? condition.field ?? 'cond'}-${idx}`;
            return idx === 0 ? (
              <RuleConditionDisplay key={conditionKey} condition={condition} />
            ) : (
              <React.Fragment key={conditionKey}>
                <br />
                <RuleConditionDisplay condition={condition} />
              </React.Fragment>
            );
          })}
        {isNotNull(group.groups) &&
          group.groups.map((childGroup: RuleGroup, idx: number) => {
            const groupKey = `${childGroup.id ?? childGroup.operator ?? 'group'}-${idx}`;
            return idx === 0 ? (
              <RuleGroupDisplay key={groupKey} group={childGroup} />
            ) : (
              <React.Fragment key={groupKey}>
                <br />
                <RuleGroupDisplay group={childGroup} />
              </React.Fragment>
            );
          })}
      </div>
    </Flex>
  );
};

export default RuleGroupDisplay;
